import React, { Component } from 'react';
import { DragSource } from 'react-dnd';
import avatar from "./avatar.png";
import config from '../../config';

const cardSource = {
  beginDrag(props) {
    return {
      id: props.employee.id,
    };
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

class Employee extends Component {
  render() {
    const { connectDragSource, employee, availabilityMeter, leaveIndicator } = this.props;

    let employeeAvatar = employee.avatar ? employee.avatar : avatar;

    if (new RegExp('^\\/uploads').test(employeeAvatar)) {
      employeeAvatar = `${config.appUrl}${employeeAvatar}`;
    }

    const thumb = connectDragSource(
      <div
        className="employeebar__thumb"
        style={{ backgroundImage: `url(${employeeAvatar})`, borderColor: employee.color }}
      />
    );

    return (
      <div className="employeebar__item">
        {thumb}

        <div className="employeebar__item-content">
          <div className="employeebar__item-name">{leaveIndicator} {employee.fullname}</div>
          <div className="employeebar__item-function">{employee.function}</div>

          {availabilityMeter}
        </div>
      </div>
    );
  }
}

// Export the wrapped component:
export default DragSource('group', cardSource, collect)(Employee);



// WEBPACK FOOTER //
// ./src/components/EmployeeBar/Employee.js